var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "lesspricerequest-component" }, [
    _c(
      "button",
      {
        staticClass:
          "product-over-actions__btn btn btn--surface-container-highest",
        attrs: {
          "data-bs-toggle": "modal",
          "data-bs-target": "#oneClickOrderModal",
        },
      },
      [_vm._v("\n      Купить в один клик")]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "oneClickOrderModal",
          tabindex: "-1",
          "aria-hidden": "true",
        },
      },
      [
        _c("div", { staticClass: "modal-dialog modal__dialog" }, [
          _c("div", { staticClass: "modal-content modal-dialog__content" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body modal-content__body" },
              [
                _c("p", [
                  _vm._v(
                    "Оставьте контакты, менеджер свяжется с Вами, чтобы оформить заказ максимально быстро и удобно."
                  ),
                ]),
                _vm._v(" "),
                _vm.product
                  ? _c("product-simple", { attrs: { product: _vm.product } })
                  : _vm._e(),
                _vm._v(" "),
                _vm.contact && _vm.step == "form"
                  ? _c("one-click-order-form", {
                      staticClass: "mt-4",
                      attrs: { contact: _vm.contact, errors: _vm.errors },
                      on: { "send-form": _vm.sendForm },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.step == "complete"
                  ? _c("div", [
                      _c("p", { staticClass: "text-success" }, [
                        _vm._v(
                          "\n              Ваше сообщение успешно отправлено! Мы свяжемся с Вами в ближайшее время.\n            "
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header modal-content__header" }, [
      _c(
        "h5",
        {
          staticClass: "modal-title modal-header__title",
          attrs: { id: "oneClickOrderModalLabel" },
        },
        [_vm._v("Быстрая покупка")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close modal-header__close-btn",
          attrs: {
            type: "button",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
          },
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }